// ============================================================================
// MULTI-BRAND HOSPITALITY DATA LAYER
// This is the reusable architecture. Each property is a "brand" object with the
// same shape. Swapping/adding a restaurant = adding a config object here.
// River Stone Chophouse is the fully-realized flagship brand.
// ============================================================================

export const IMG = {
  logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/hda8q6kj_RSChop%2Blogo-white%2Bline.webp",
  hero: "https://images.unsplash.com/photo-1570560258879-af7f8e1447ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  steakFlame: "https://static.prod-images.emergentagent.com/jobs/003dc7a2-a9de-4144-8ea6-4cc99f930c69/images/3334605dd222639d4094b43acbc4243502bc13ad3cfb173487fbed6633d30f6c.jpeg",
  privateDining: "https://static.prod-images.emergentagent.com/jobs/003dc7a2-a9de-4144-8ea6-4cc99f930c69/images/cbd80136fe9cce16c38ded5d3d33e62188d4493fd2f53a5861b35dc79df132d6.jpeg",
  fireplace: "https://static.prod-images.emergentagent.com/jobs/003dc7a2-a9de-4144-8ea6-4cc99f930c69/images/cc8574c5ff69d3fe6b2c15ca90a8102637cb2fdefb5da46521694995a5345652.jpeg",
  reservationTable: "https://static.prod-images.emergentagent.com/jobs/003dc7a2-a9de-4144-8ea6-4cc99f930c69/images/2c38323cc8ba1b05201d8221f9a0ab46e34dbe6bc9c78b2a274e9b749ed45ead.jpeg",
  steakPlated: "https://images.pexels.com/photos/37121071/pexels-photo-37121071.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1000",
  oysters: "https://images.unsplash.com/photo-1633321094192-388268512e0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lobster: "https://images.unsplash.com/photo-1503414382497-bfd17f3c2e41?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cocktail: "https://images.pexels.com/photos/19510302/pexels-photo-19510302.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1000",
  chefPlating: "https://images.pexels.com/photos/36430088/pexels-photo-36430088.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1000",
  wineCellar: "https://images.unsplash.com/photo-1724882207681-9e7e8c3dd45c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  rawBar: "https://images.pexels.com/photos/10895800/pexels-photo-10895800.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1000",
};

export const riverStone = {
  id: "river-stone",
  name: "River Stone Chophouse",
  shortName: "River Stone",
  tagline: "Artfully Crafted. Exceptionally Served.",
  kicker: "Steaks • Seafood • Raw Bar",
  location: {
    city: "Suffolk",
    region: "Coastal Virginia",
    address: "8032 Harbour View Boulevard",
    cityStateZip: "Suffolk, Virginia 23435",
    mapUrl: "https://www.google.com/maps/place/River+Stone+Chophouse/@36.893871,-76.4366614,17z",
  },
  phone: "(757) 638-7990",
  phoneHref: "tel:7576387990",
  email: "reservations@riverstonechophouse.com",
  social: {
    instagram: "https://www.instagram.com/river_stone_chophouse/",
    facebook: "https://www.facebook.com/riverstonechophouse/",
  },
  googleReviewsUrl: "https://share.google/wcmvRIdZI3LqpnGD4",
  hours: [
    { day: "Dining Room", time: "Mon–Sat 5 PM · Sun 4 PM" },
    { day: "Lounge", time: "Mon–Fri 3 PM · Sat 5 PM · Sun 4 PM" },
    { day: "Happy Hour", time: "Mon–Fri 3 PM – 6 PM" },
  ],
  happyHour: {
    days: "Monday – Friday",
    time: "3 PM – 6 PM",
    highlight: "Cocktails • Wine • Beer • Martinis",
  },
  intro:
    "Coastal Virginia's premier chophouse — an Arts & Crafts inspired space of stone fireplaces, romantic booths, a spirited raw bar and dramatic lighting. Premium steaks, the freshest seafood and an award-winning cellar, served with quiet, considered hospitality.",
};

export const experiences = [
  {
    n: "01",
    title: "Aged In House",
    subtitle: "28-Day Dry-Aged Hereford Beef",
    copy: "Whole primals aged in our own cellar for a minimum of twenty-eight days, developing a depth of flavour and tenderness impossible to rush.",
    image: IMG.steakFlame,
  },
  {
    n: "02",
    title: "From The Water",
    subtitle: "Fresh Seafood & Raw Bar",
    copy: "Oysters shucked to order, chilled towers and daily catches drawn from cold Atlantic waters to a warm coastal table.",
    image: IMG.oysters,
  },
  {
    n: "03",
    title: "From The Cellar",
    subtitle: "Award-Winning Wine Selection",
    copy: "A considered list spanning old-world classics and Virginia's own vineyards, guided by a team that reads the room as well as the label.",
    image: IMG.wineCellar,
  },
];

export const signatures = [
  { name: "28-Day Dry-Aged Ribeye", note: "Bone-in • Hereford", image: IMG.steakPlated },
  { name: "Chilled Oyster Selection", note: "Raw Bar • Shucked to order", image: IMG.oysters },
  { name: "Maine Lobster", note: "Butter-poached", image: IMG.lobster },
  { name: "Chef's Seasonal Feature", note: "Ask your server", image: IMG.chefPlating },
];

// NOTE: Menu content now lives in the authoritative src/data/menuData.js.

// ---- PRIVATE DINING ROOMS (verified from live site) ----
const SQ = "https://images.squarespace-cdn.com/content/v1/60b4d9722f1b2b7584c62158";
export const rooms = [
  {
    name: "Wright Room",
    image: `${SQ}/1776980488875-8IIIFN8Y0R2UKLQZKKL0/IMG_8407.jpg`,
    sqft: 530,
    tour: "https://my.matterport.com/show/?m=zQioezA7Neu",
    desc: "Our sophisticated board room with state-of-the-art video & sound — a 60\u2033 plasma screen, laptop & DVD connections, and in-room volume controls.",
    caps: [["Boardroom", 22], ["U-Shape", 22], ["Reception", 40], ["Classroom", 14]],
    amenities: ["60\u2033 Plasma & AV", "In-Room Volume", "Board-Room Setting"],
  },
  {
    name: "Oak Park Room",
    image: `${SQ}/1776980493341-YFKLRM04YZ6Y6BC9AED3/IMG_8370.jpg`,
    sqft: 1050,
    tour: "https://my.matterport.com/show/?m=7sWgkRktjh4",
    desc: "Our largest private dining room, featuring a built-in bar for receptions and full presentation wiring.",
    caps: [["Banquet", 64], ["Reception", 75], ["Classroom", 48]],
    amenities: ["Built-In Bar", "Presentation-Wired", "Grand Receptions"],
  },
  {
    name: "Robie Room",
    image: `${SQ}/1776980489181-N58JZUJQDHWTHYX1AE52/IMG_8390.jpg`,
    sqft: 530,
    tour: "https://my.matterport.com/show/?m=jApRKdabpmP",
    desc: "An elegant room that connects to the Wright or Oak Park rooms and is wired for presentations.",
    caps: [["Banquet", 32], ["Reception", 40], ["Classroom", 24]],
    amenities: ["Connects to Wright / Oak Park", "Presentation-Wired"],
  },
  {
    name: "Taliesin Room",
    image: `${SQ}/1776980493435-WI5H1WONPWPMH6IPZOPL/IMG_8347.jpg`,
    sqft: 210,
    tour: "https://my.matterport.com/show/?m=2aCZaCukYT2",
    desc: "An intimate room with an attractive built-in wine wall and tufted banquette seating — ideal for smaller gatherings.",
    caps: [["Seated", 14]],
    amenities: ["Built-In Wine Wall", "Tufted Banquette", "Communal Table"],
  },
  {
    name: "Oak Park & Robie Combined",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/77fz9nkp_Screenshot%202026-08-19%20at%203.21.56%E2%80%AFPM.webp",
    sqft: 1630,
    tour: "https://my.matterport.com/show/?m=U22VX2U9WmV",
    desc: "Two interconnected rooms forming a single-floor event venue with elegant coffered ceilings and rich wood accents.",
    caps: [["Banquet", 100], ["Reception", 120], ["Classroom", 90]],
    amenities: ["1,630 sq ft", "Interconnected Rooms"],
  },
];

export const grandCombo = {
  name: "All Rooms & Upstairs Foyer",
  reception: 250,
  desc: "The full second floor combined — our largest configuration for grand receptions of up to 250 guests.",
};

export const eventsCoordinator = {
  name: "Kati Newman",
  title: "Special Events Coordinator",
  email: "kati.newman@packbrothershospitality.com",
};
export const offeringsPacket = "https://www.riverstonechophouse.com/s/Website-RSCH-Packet-0031226.pdf";

export const eventTypes = [
  "Corporate Meetings",
  "Rehearsal Dinners",
  "Birthdays",
  "Anniversaries",
  "Holiday Parties",
  "Private Celebrations",
  "Receptions",
  "AV / Presentation",
];

// ---- MULTI-BRAND VISION (real Pack Brothers Hospitality portfolio) ----
const ART = "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts";
export const portfolio = [
  { name: "River Stone Chophouse", type: "Steaks & Seafood", city: "Suffolk, VA", accent: "#C1272D", live: true, logo: `${ART}/hda8q6kj_RSChop%2Blogo-white%2Bline.webp` },
  { name: "The Surry Seafood Co.", type: "Waterfront Seafood", city: "Surry, VA", accent: "#2a7a6b", logo: `${ART}/0ynm94dd_Surry_Seafood_v3.webp` },
  { name: "Smithfield Station", type: "Waterfront Inn & Dining", city: "Smithfield, VA", accent: "#1f3a5f", logoMax: 84, logo: `${ART}/rnglc9mm_Smithfield_Station_logo_final-01.webp` },
  { name: "Vintage Tavern", type: "Farm-to-Table", city: "Suffolk, VA", accent: "#6b7a3a", logo: `${ART}/yebsv6f7_VintageTavernPMSrLogo.webp` },
  { name: "Decoys Seafood", type: "Casual Seafood", city: "Suffolk, VA", accent: "#b5763a", logo: `${ART}/fkynau9d_Decoys-Final-Logo-Color_nobox.webp` },
  { name: "Bennett's Creek Marina", type: "Marina & Grill", city: "Suffolk, VA", accent: "#3a5a7a", logo: `${ART}/ac571yqv_BCM-Logo-Final-Color.webp` },
  { name: "Old Point Comfort Marina", type: "Marina & Dining", city: "Fort Monroe, VA", accent: "#5a8ca0", logo: `${ART}/tcd9q0or_logo-01.webp` },
  { name: "37 North at Fort Monroe", type: "Coastal Dining", city: "Fort Monroe, VA", accent: "#7a2e3a", logo: `${ART}/pd7v15l9_logo2-01.webp` },
];

export const visionBenefits = [
  { title: "Individual Brand Identity", copy: "Every property maintains its own personality — logo, palette, typography and voice." },
  { title: "Shared Technology", copy: "Common infrastructure removes unnecessary duplication across the portfolio." },
  { title: "Central Management", copy: "Menus, hours and content managed efficiently across every property." },
  { title: "Cross-Promotion", copy: "Guests discovering one property easily discover the rest of the family." },
];

export const sharedEcosystem = [
  "Website Infrastructure", "Analytics", "SEO Framework", "Reservation Integrations",
  "Event Management", "Careers", "Gift Cards", "Customer Data", "Email Marketing", "Cross-Property Promotion",
];

// ---- SISTER RESTAURANTS (Pack Brothers Hospitality family) ----
// Order as specified by owner. Add/reorder objects here to change the wall.
export const sisterBrands = [
  { name: "The Surry Seafood Co.", h: 72, logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/0ynm94dd_Surry_Seafood_v3.webp" },
  { name: "Smithfield Station", h: 104, logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/rnglc9mm_Smithfield_Station_logo_final-01.webp" },
  { name: "Vintage Tavern", h: 76, logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/yebsv6f7_VintageTavernPMSrLogo.webp" },
  { name: "River Stone Chophouse", h: 80, logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/hda8q6kj_RSChop%2Blogo-white%2Bline.webp" },
  { name: "Decoys Seafood", h: 52, logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/fkynau9d_Decoys-Final-Logo-Color_nobox.webp" },
  { name: "Bennett's Creek Marina", h: 72, logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/ac571yqv_BCM-Logo-Final-Color.webp" },
  { name: "Old Point Comfort Marina", h: 68, logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/tcd9q0or_logo-01.webp" },
  { name: "37 North at Fort Monroe", h: 72, logo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_riverstone-preview/artifacts/pd7v15l9_logo2-01.webp" },
];

export const nav = [
  { label: "Menu", to: "/menu" },
  { label: "Experience", to: "/#experience" },
  { label: "Private Dining", to: "/private-dining" },
  { label: "Events", to: "/private-dining#events" },
  { label: "About", to: "/our-story" },
];

// Dropdown navigation IA (reorganized from the legacy site) — mega-menu ready.
// Each top item has a `feature` (visual promo) and children with short `desc`.
export const navMenu = [
  {
    label: "Menu", to: "/menu",
    feature: {
      image: "STEAK_PLATED", eyebrow: "Artfully Crafted",
      title: "The Signature Ribeye", blurb: "22 oz, dry-aged in-house for 28 days.", to: "/menu?section=dinner",
    },
    children: [
      { label: "Dinner Menu", to: "/menu?section=dinner", desc: "Hand-cut steaks, seafood & raw bar" },
      { label: "Bar Bites", to: "/menu?section=bar-bites", desc: "Casual lounge favorites" },
      { label: "Desserts", to: "/menu?section=desserts", desc: "House-made by our pastry chef" },
      { label: "Wine & Cocktails", to: "/menu?section=wine", desc: "Award-winning cellar & bar" },
      { label: "Cigars", to: "/menu?section=cigars", desc: "Curated list on the stone patio" },
      { label: "Specials", to: "/menu?section=specials", desc: "Happy hour & weekly features" },
    ],
  },
  {
    label: "Experience", to: "/#experience",
    feature: {
      image: "COCKTAIL", eyebrow: "The Lounge",
      title: "Happy Hour", blurb: "Mon–Fri, 3–6 PM in the lounge & patio.", to: "/menu?section=specials",
    },
    children: [
      { label: "The River Stone Experience", to: "/#experience", desc: "Coastal Virginia's premier chophouse" },
      { label: "Signature Experiences", to: "/#signatures", desc: "Aged in-house, from the water & cellar" },
      { label: "The Lounge", to: "/#lounge", desc: "Cocktails, wine & a vibrant bar scene" },
      { label: "Events & Specials", to: "/menu?section=specials", desc: "Oyster Mondays, Prime Rib Tuesdays & more" },
    ],
  },
  {
    label: "Private Dining", to: "/private-dining",
    feature: {
      image: "PRIVATE_DINING", eyebrow: "Up to 250 Guests",
      title: "Celebrate at River Stone", blurb: "Four private rooms with full AV.", to: "/private-dining#events",
    },
    children: [
      { label: "Private Dining Overview", to: "/private-dining", desc: "Distinctive spaces for every occasion" },
      { label: "Rooms & Capacities", to: "/private-dining#rooms", desc: "Seated & reception configurations" },
      { label: "Corporate Events", to: "/private-dining#events", desc: "Meetings with AV & presentation" },
      { label: "Celebrations", to: "/private-dining#events", desc: "Rehearsals, birthdays & anniversaries" },
      { label: "Plan Your Event", to: "/private-dining#events", desc: "Start your inquiry today" },
    ],
  },
  {
    label: "About", to: "/our-story",
    feature: {
      image: "FIREPLACE", eyebrow: "Since 2008",
      title: "Our Story", blurb: "Coastal Virginia's original in-house dry-age program.", to: "/our-story",
    },
    children: [
      { label: "Our Story", to: "/our-story", desc: "History, craft & hospitality" },
      { label: "Dress Code", to: "/dress-code", desc: "Business casual in the dining room" },
      { label: "Hours & Location", to: "/reservations#contact", desc: "Harbour View, Suffolk VA" },
      { label: "Careers", to: "/our-story#careers", desc: "Join an award-winning team" },
      { label: "Contact", to: "/reservations#contact", desc: "Call, email or visit" },
    ],
  },
];

export const footerNav = [
  { label: "Menu", to: "/menu" },
  { label: "Reservations", to: "/reservations" },
  { label: "Private Dining", to: "/private-dining" },
  { label: "Dress Code", to: "/dress-code" },
  { label: "Our Story", to: "/our-story" },
  { label: "Careers", to: "/our-story#careers" },
  { label: "Gift Cards", href: "https://riverstonechophouse.digitalgiftcardmanager.com/" },
  { label: "Feedback", href: "https://www.riverstonechophouse.com/feedback" },
];
